import { useState, useEffect } from 'react';
import _ from 'lodash';
import getFormLocal from './getFormLocal';

export default function useHide(formId, sectionId, questionId) {
  let initialValue = false; // test uniquement pour le form 0
  if (formId === 0 || formId === '0') initialValue = 'loading';
  const [value, setValue] = useState(initialValue);
  const path = `inspection.children.${sectionId}.children.${questionId}.hide`;

  const refreshValue = () => {
    getFormLocal(formId).then((form) => {
      const storedValue = _.get(form, path, false);
      setValue(storedValue);
    });
  };

  // init the value
  useEffect(() => {
    refreshValue();
  }, [path]);

  return [value];
}
